import { IAuthenticateResponseData } from '@GFTypes/Responses/AuthenticateResponse';
import { EActionName } from '@Managers/Events/EActionName';
import { TUserAction } from '@Managers/Events/GameEvents';
import { TUserActionResponse } from '@Services/HttpService/HttpService.types';

export interface IMaintenance {
    isUnderMaintenance: true;
}

export enum EWinType {
    NORMAL_WIN = 'WIN',
    BIG_WIN = 'BIG_WIN',
    HUGE_WIN = 'HUGE_WIN',
    MEGA_WIN = 'MEGA_WIN',
    JACKPOT_WIN = 'JACKPOT_WIN',
    JACKPOT_WIN_1 = 'JACKPOT_WIN_1',
    JACKPOT_WIN_2 = 'JACKPOT_WIN_2',
    JACKPOT_WIN_3 = 'JACKPOT_WIN_3',
    JACKPOT_WIN_4 = 'JACKPOT_WIN_4',
    JACKPOT_WIN_5 = 'JACKPOT_WIN_5'
}

export enum EJackpotType {
    MINI_JACKPOT = 'MINI_JACKPOT',
    MINOR_JACKPOT = 'MINOR_JACKPOT',
    MAJOR_JACKPOT = 'MAJOR_JACKPOT',
    GRAND_JACKPOT = 'GRAND_JACKPOT'
}

export interface IHttpError {
    actionName?: string;
    code?: string | number;
    statusCode?: number;
    error?: string;
    actionPayload?: TUserAction;
    networkError?: boolean;
    requestError?: boolean;
}

export interface IReconnectNotification {
    active: boolean;
    tryAttepmt: number;
    maxTries: number;
}
export interface IInitialState {
    sessionStatusCheck: 'idle' | 'Checking' | 'Check fulfilled';
    configurationDataLoaded: boolean;
    authenticateResponseData: undefined | IAuthenticateResponseData;
    userActionResponseData: TUserActionResponse & { actionName: EActionName };
    httpError: IHttpError | false;
    reconnectNotification: IReconnectNotification;
    pendingRequest?: TUserAction | false;
}

export const RECONNECT_NOTIFICATION_DEFAULTS = {
    active: false,
    tryAttepmt: 0,
    maxTries: 0
};

export const initialState: IInitialState = {
    sessionStatusCheck: 'idle',
    configurationDataLoaded: false,
    authenticateResponseData: undefined,
    userActionResponseData: {
        actionName: EActionName.SPIN,
        account: {
            currency: {
                code: 'EUR',
                exponent: 0
            },
            balance: 0,
            bonuses: []
        },
        result: {
            outcome: [
                {
                    win: 0,
                    gameType: 1
                }
            ]
        }
    },
    httpError: false,
    reconnectNotification: RECONNECT_NOTIFICATION_DEFAULTS
};
